export function EbikLogo({ variant = "light", showText = true, size = 38, className = "" }) {
  const word = variant === "light" ? "#0B0F17" : "#FFFFFF";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="ebik-logo">
      <svg width={size} height={size} viewBox="0 0 100 100" fill="none" aria-label="Ebik">
        <path
          d="M50 89C46 83 13 63 8 36 4 15 27 6 40 15c5 3 8 8 10 13 2-5 5-10 10-13 13-9 36 0 32 21-5 27-38 47-42 53Z"
          fill="#DC2626"
        />
        <path
          d="M50 89C46 83 13 63 8 36 4 15 27 6 40 15c5 3 8 8 10 13"
          fill="#B91C1C" opacity="0.55"
        />
        <text x="52" y="62" textAnchor="middle" fontFamily="Outfit, sans-serif"
          fontStyle="italic" fontWeight="800" fontSize="46" fill="#FFFFFF">e</text>
      </svg>
      {showText && (
        <div className="leading-none">
          <div className="font-heading font-extrabold text-[1.35rem] tracking-tight" style={{ color: word }}>
            Ebik
          </div>
          <div className="font-mono text-[0.55rem] tracking-[0.35em]" style={{ color: "#DC2626" }}>
            LOGISTICS
          </div>
        </div>
      )}
    </div>
  );
}
